import { createSlice } from '@reduxjs/toolkit';
import { formURL } from '@wsc/utils/apiUtils';
import { createRandomNumber } from '../../utils/functionUtils'

export const prepareDefaultSelections = (customizations) => {
	return customizations.map((customization) => {
		const color = customization?.colors ? customization.colors[createRandomNumber(customization.colors?.length)] : null
		const _selected = {
			...customization.options[createRandomNumber(customization.options?.length)],
		};
		if (_selected && customization.kind === 'texture-swap') {
			_selected.texture_url = formURL(_selected.texture_url);
		}
		return {
			...customization,
			selected: _selected,
			color: color,
			meshes: customization.options
		};
	});
};

const storeAvatarsReducer = createSlice({
	name: 'storeAvatars',
	initialState: [],
	reducers: {
		initialize: (state, action) => {
			let selectedAvatar;

			if (action.payload?.[0]) {
				selectedAvatar = {};
				selectedAvatar._id = action.payload[0]._id.$oid;
				selectedAvatar.glbUrl = formURL(action.payload[0].url);
				selectedAvatar.image = formURL(action.payload[0].image);
				selectedAvatar.name = action.payload[0].name;
				selectedAvatar.scale = action.payload[0].scale || 1.0;
				selectedAvatar.animations = action.payload[0].animations;
				selectedAvatar.customizations = prepareDefaultSelections(
					action.payload[0].customizations,
				);
				selectedAvatar.initialRotation = action.payload[0].initialRotation || 0;
			}
			return {
				allAvatars: action.payload,
				selectedAvatar,
			};
		},
		setSelectedAvatar: (state, action) => {
			state.selectedAvatar = action.payload;
		},
	},
});

export default storeAvatarsReducer.reducer;
